var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "task-main",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "btns"
  }, [_c('div', {
    staticClass: "btn btn-create",
    on: {
      "click": _vm.onCreate
    }
  }, [_vm._v("创建新任务")]), _c('div', {
    staticClass: "btn btn-create",
    on: {
      "click": _vm.onRefresh
    }
  }, [_vm.isLoading ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)]), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab",
    class: _vm.selectTab == 0 && 'active',
    on: {
      "click": function ($event) {
        _vm.selectTab = 0;
        _vm.condition.page = 1;
        _vm.onRefresh();
      }
    }
  }, [_vm._v("启用的")]), _c('div', {
    staticClass: "tab",
    class: _vm.selectTab == 1 && 'active',
    on: {
      "click": function ($event) {
        _vm.selectTab = 1;
        _vm.condition.page = 1;
        _vm.onRefresh();
      }
    }
  }, [_vm._v("禁用的")])]), _c('div', {
    staticClass: "search-box btns"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_vm._v(" 类型： "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.condition.type,
      expression: "condition.type"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.condition, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v(" 全部 ")]), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(" 任务奖励 ")]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(" 邀请奖励 ")])])]), _c('div', {
    staticClass: "form-item"
  }, [_vm._v(" 开始时间： "), _c('m-date-picker-a', {
    attrs: {
      "value": _vm.condition.start_time
    },
    on: {
      "inputFn": v => _vm.changeDate('start_time', v)
    }
  })], 1), _c('div', {
    staticClass: "form-item"
  }, [_vm._v(" 结束时间： "), _c('m-date-picker-a', {
    attrs: {
      "value": _vm.condition.end_time
    },
    on: {
      "inputFn": v => _vm.changeDate('end_time', v)
    }
  })], 1), _c('div', {
    staticClass: "btn btn-create",
    on: {
      "click": _vm.onRefresh
    }
  }, [_vm.isLoading ? [_vm._v("查询中...")] : [_vm._v("查询")]], 2)]), _c('div', {
    staticClass: "task-list"
  }, [_vm._m(0), _vm._l(_vm.list, function (item, index) {
    return _c('div', {
      staticClass: "task-list-item"
    }, [_c('div', {
      staticClass: "s"
    }, [_vm._v(" " + _vm._s(item.id) + " ")]), _c('div', {
      staticClass: "s"
    }, [item.type == 0 ? [_vm._v(" 任务奖励 ")] : [_vm._v(" 邀请奖励 ")]], 2), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(_vm.cutStr(item.start_time)) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(_vm.cutStr(item.end_time)) + " ")]), _c('div', {
      staticClass: "s"
    }, [item.is_award == 1 ? [_vm._v(" 已发奖 ")] : [_vm._v(" 未发奖 ")]], 2), _c('div', {
      staticClass: "s"
    }, [item.status == 1 ? [_vm._v(" 启用中 ")] : [_vm._v(" 禁用中 ")]], 2), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.remark) + " ")]), _c('div', {
      staticClass: "s opt"
    }, [_c('div', {
      staticClass: "btn",
      on: {
        "click": function ($event) {
          return _vm.onReward(item.id);
        }
      }
    }, [_vm._v("奖项")]), item.is_award == 0 ? _c('div', {
      staticClass: "btn",
      on: {
        "click": function ($event) {
          return _vm.onSendReward(item.id);
        }
      }
    }, [_vm._v("发放奖励")]) : _c('div', {
      staticClass: "btn",
      on: {
        "click": function ($event) {
          return _vm.onLogs(item.id);
        }
      }
    }, [_vm._v("获奖名单")]), _c('div', {
      staticClass: "btn",
      on: {
        "click": function ($event) {
          return _vm.onModify(item);
        }
      }
    }, [_vm._v("编辑")])])]);
  })], 2), _c('div', {
    staticClass: "data-bd"
  }, [_c('my-pagination', {
    staticClass: "pagination",
    attrs: {
      "total": _vm.total,
      "page-size": _vm.condition.limit,
      "page": _vm.condition.page,
      "on-page-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })], 1), _c('pop-rank-activity', {
    attrs: {
      "show": _vm.popTaskShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popTaskShow = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "task-list-item"
  }, [_c('div', {
    staticClass: "s"
  }, [_vm._v(" ID ")]), _c('div', {
    staticClass: "s"
  }, [_vm._v(" 类型 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 开始时间 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 结束时间 ")]), _c('div', {
    staticClass: "s"
  }, [_vm._v(" 是否发奖 ")]), _c('div', {
    staticClass: "s"
  }, [_vm._v(" 状态 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 备注 ")]), _c('div', {
    staticClass: "s opt"
  }, [_vm._v(" 操作 ")])]);
}];
export { render, staticRenderFns };